<template>
  <el-dialog title="调班" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="110px">
      <el-form-item label="值班人：" prop="custServiceId">
        <el-select v-model="form.custServiceId" placeholder="请选择" clearable size="small">
          <el-option v-for="(item,index) in serviceOptions" :key="index" :label="item.realName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import courseSubjectBarrierDutyTeacher from '@/api/course/courseSubjectBarrierDutyTeacher'
function initFormBean() {
  const formBean = {
    custServiceId: null,
  }
  return formBean
}

export default {
  props: ['serviceOptions'],
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {

      },
      userOptions: [],
      rowItem: null
    }
  },
  created() {

  },
  methods: {
    handleSwitch(row) {
      this.rowItem = row
      this.formVisible = true
    },
    doCreate() {

      let { custServiceId } = this.form;
      if (!custServiceId) return this.$message.error('请选择值班人')
      let params = {
        barrierId: this.rowItem.barrierId,
        dutyTime: this.rowItem.dutyTime,
        custServiceId,
        id: this.rowItem.id,
      }
      courseSubjectBarrierDutyTeacher.update(params).then(res => {
        if (res.code === '0') {
          this.$message.success('操作成功')
          this.formVisible = false;
          this.$emit('created')
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
</style>
